var _rect, _polygon, _rect2, _rect3, _rect4, _circle, _circle2, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChurchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "churchGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#F5F0E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#E5DECF"
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 32,
    width: 32,
    height: 24,
    fill: "url(#churchGradient)",
    rx: 2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "32,8 40,28 24,28",
    fill: "#5F7A61"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 8,
    width: 4,
    height: 8,
    fill: "#FFFFFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 10,
    width: 8,
    height: 4,
    fill: "#FFFFFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 44,
    width: 8,
    height: 12,
    fill: "#1C1917",
    rx: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 40,
    r: 3,
    fill: "#FFFFFF",
    opacity: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 40,
    r: 3,
    fill: "#FFFFFF",
    opacity: 0.8
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 56,
    width: 36,
    height: 4,
    fill: "#E5DECF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurchIcon);
export default __webpack_public_path__ + "static/media/church-icon.123a4dfb8158031dbbf719f8d1d13127.svg";
export { ForwardRef as ReactComponent };